import { createSelector } from 'reselect';
import { flow, get, reject, values } from 'lodash/fp';

import t from '../utils/translate';
import { getColumns } from '../utils/challengeUtils';
import routeFilterSelector from './routeFilterSelector';

function getChallenges(liveChallenges, myLiveChallenges, isSignedIn, routeFilter) {
  if (!isSignedIn) {
    return [
      {
        key: 'live',
        title: t('Live Challenges'),
        challenges: routeFilter(liveChallenges).filter(ch => ch.sticky || ch.isFeatured),
        columns: getColumns({ live: true, entered: false }),
        emptyTitle: t('No Live Challenges'),
        emptyMessage: t('There are no live challenges'),
        alwaysShow: true
      }
    ];
  }

  return [
    {
      key: 'myLive',
      title: t('My Live Challenges'),
      challenges: routeFilter(myLiveChallenges),
      columns: getColumns({ live: true, entered: true }),
      emptyTitle: t('No Live Challenges'),
      emptyMessage: t('The challenges that you entered will appear here'),
      alwaysShow: true
    },
    {
      key: 'other',
      title: t('Other Live Challenges'),
      challenges: routeFilter(reject('hasEntered', liveChallenges)).filter(
        ch => ch.sticky || ch.isFeatured
      ),
      columns: getColumns({ live: true, entered: false }),
      emptyTitle: t('No Other Live Challenges'),
      emptyMessage: t('There are no other live challenges'),
      alwaysShow: true
    }
  ];
}

const liveChallengesSelector = createSelector(
  get('liveChallenges.challenges'),
  flow(
    get('myChallenges.live.challenges'),
    values
  ),
  get('user.isSignedIn'),
  routeFilterSelector,
  getChallenges
);

export default liveChallengesSelector;
